import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Modal, Popover} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'orgName', 
        label: '所属部门', 
        width: 100
    },
    {
        key:'teamName', 
        label: '团队名称', 
        width: 100
    },
    {
        key:'teamTypeName', 
        label: '团队类型', 
        width: 100
    },
    {
        key:'leaderCode', 
        label: '负责人工号', 
        width: 100
    },
    {
        key:'leaderName', 
        label: '负责人姓名', 
        width: 100
    },
    {
        key:'userNames', 
        label: '团队成员', 
        width: 100,render: (value,row) =>
        <span> 
            <Popover placement="topLeft" style={{ width: 300 }}  content={
                <div style={{ width: 200 }}>
                    {
                        row.userNames
                    }
                </div>} 
                title="团队成员"
                >
                {value}
            </Popover>
        </span> 
    },
    {
        key:'count', 
        label: '团队人数', 
        width: 100
    },
    {
        key:'teamStateDesc', 
        label: '记录生成状态', 
        width: 120
    },
    {
        key:'resultDate', 
        label: '记录生成时间', 
        width: 120
    },
    {
        key:'teamDesc', 
        label: '团队描述', 
        width: 150,render: (value,row) =>
        <span> 
            <Popover placement="topLeft" style={{ width: 300 }}  content={
                <div style={{ width: 200 }}>
                    {
                        row.teamDesc
                    }
                </div>} 
                title="团队描述"
                >
                {value}
            </Popover>
        </span> 
    },
    {
        key:'email', 
        label: '团队邮箱', 
        width: 100
    },
    {
        key:'tel', 
        label: '团队手机号', 
        width: 100
    },
    {
        key:'createUserName', 
        label: '团队创建人', 
        width: 150
    },
    {
        key:'teamCreateTime', 
        label: '团队创建时间', 
        width: 150
    }
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zgcp/team/query?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchById = (id) => {
    return fetch.get('zgcp/team/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

const querySearchByName = (keywords ={}) => {
    return fetch.post('zgcp/team/findbyname', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.id,
            label: d.teamName,
        }));
    });
}

const getRoleByUser = (data) => {
    return fetch.post('zgcp/team/getRoleByUser',data?data:{})
    .then(response => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
 const insert = (data) => {
    return fetch.post('zgcp/team/insert', data)
    .then(response => {
        if(response.code === 200) {
            return response;
        }
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('zgcp/team/update/' + id, data)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/team/delete/', ids)
    .then(response => {
        return response;
    });
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    batchRemove,
    update,
    insert,
    querySearchById,
    getRoleByUser,
    querySearchByName
}